/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ date: NonNullable<unknown> }} Scheduledcancellationdescription2Inputs */

const en_scheduledcancellationdescription2 = /** @type {(inputs: Scheduledcancellationdescription2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Your subscription ends on ${i?.date}.`)
};

const de_scheduledcancellationdescription2 = /** @type {(inputs: Scheduledcancellationdescription2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Dein Abonnement endet am ${i?.date}.`)
};

/**
* | output |
* | --- |
* | "Your subscription ends on {date}." |
*
* @param {Scheduledcancellationdescription2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const scheduledcancellationdescription2 = /** @type {((inputs: Scheduledcancellationdescription2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Scheduledcancellationdescription2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_scheduledcancellationdescription2(inputs)
	return de_scheduledcancellationdescription2(inputs)
});
export { scheduledcancellationdescription2 as "scheduledCancellationDescription" }